import React, { useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import GHref from 'tennders-market/common/components/element/GHref'
import GButton from 'tennders-common/form/components/GButton'
import usePassword from 'tennders-auth/hooks/usePassword'
import RuleCheck from 'tennders-auth/components/RuleCheck'
import { InputLabeledContainer } from 'tennders-common/form/components'
import Password from 'tennders-common/form/components/new-inputs/Password'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

const PasswordChange = () => {
  const [saving, setSaving] = useState(false)
  const [form, setForm] = useState({})
  const [errors, setErrors] = useState([])
  const [showPassword, setShowPassword] = useState(false)
  const { t } = useTranslation()

  const onChange = (k, v) => {
    setForm({ ...form, [k]: v })
  }

  const {
    submitUpdatePassword,
    rules,
    rePasswordRules,
    submitNotAllowed
  } = usePassword({
    setErrors,
    setSaving,
    onFinish: () => {
      setShowPassword(false)
      setForm({})
    },
    form
  })

  return (
    <>
      <div className="tennders-user-menu-right-section">
        <GHref
          onClick={() => setShowPassword(!showPassword)}
          className={`tennders-user-menu-right-section-open-detail-btn${showPassword ? ' opened' : ''}`}
        >
          <span>{t('auth:changePassword')}</span>
          <FontAwesomeIcon icon={faChevronDown} aria-hidden="true" />
        </GHref>
        <div className={`tennders-user-menu-right-section-open-detail ${showPassword ? ' opened' : ''}`}>
          <InputLabeledContainer
            name="currentPassword"
            label={t('auth:currentPassword')}
            form={form}
            errors={errors}
            onChange={onChange}
            className="mb-10"
            renderInput={(rest) => <Password {...rest} />}
          />
          <InputLabeledContainer
            name="password"
            label={t('auth:password')}
            form={form}
            errors={errors}
            onChange={onChange}
            renderInput={(rest) => <Password {...rest} />}
          />
          <RuleCheck password={form.password} rules={rules} />
          <InputLabeledContainer
            form={form}
            errors={errors}
            name="passwordAgain"
            label={t('auth:newPasswordAgain')}
            onChange={onChange}
            className="mt-10"
            renderInput={(rest) => <Password {...rest} />}
          />
          <RuleCheck password={form.passwordAgain} rules={rePasswordRules} />
          <br />
          <div className="row d-flex">
            <GButton
              onClick={() => {
                setShowPassword(false)
                setForm({})
                setErrors(null)
              }}
              className="btn-border standard-btn d-block text-center mr-8"
              label={t('auth:cancel')}
            />
            <GButton
              onClick={() => submitUpdatePassword(form)}
              disabled={submitNotAllowed || !form?.currentPassword}
              submitting={saving}
              className="btn standard-btn bold tennders-add-load-buy-btn cursor-pointer"
              label={t('auth:justSave')}
            />
          </div>
        </div>
      </div>
    </>
  )
}
export default PasswordChange
